import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Layout, Spin, Icon } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import {
    Title, Tabs, SideBar, PanelLayout
} from '../../components';
import FertilizersDetail from './components/fertilizers';

import cn from '../../utils/cn';

import './style.less';

const { PanelHeader, PanelFooter, PanelContent } = PanelLayout;

@withTranslation('fertilizers')
@cn('fertilizers')
export default class Fertilizers extends Component {
    render() {
        const { cn } = this;

        const { t, history } = this.props;

        return (
            <Layout className={cn()}>
                <PanelLayout>
                    <PanelHeader>
                        <Title title={t('title')} />
                    </PanelHeader>
                    <PanelContent>
                        <FertilizersDetail />
                    </PanelContent>
                </PanelLayout>
            </Layout>
        );
    }
}